/**
 * Login View - Template
 * =====================
 * 100% presentacional: desde el título hasta el footer de términos. El
 * header (logo easycancha + hamburguesa) es chrome de la app — fuera.
 *
 * Ritmo vertical: NO hay gap uniforme en el root — cada bloque trae su
 * propio ec-mt-* (definido en BASE_CLASSES, constants.ts) que fija la
 * separación con el bloque anterior según el mockup.
 */

import { BASE_CLASSES } from './constants';

export const LOGIN_TEMPLATE: string = `
<div class="ec-login ec-flex ec-flex-col ec-w-full" ng-attr-aria-busy="{{ $ctrl.loading ? 'true' : undefined }}">

  <!-- ===== TÍTULO ===== -->
  <div class="ec-flex ec-flex-col ec-gap-2">
    <h1 class="ec-text-3xl ec-font-bold ec-text-color-text ec-leading-tight">{{ $ctrl.title }}</h1>
    <p class="ec-text-base ec-text-color-text-muted">{{ $ctrl.subtitle }}</p>
  </div>

  <!-- ===== BOTONES SOCIALES ===== -->
  <div ng-if="$ctrl.showSocial" class="${BASE_CLASSES.socialGroup}">
    <button
      ng-if="$ctrl.showApple"
      type="button"
      ng-class="$ctrl.getAppleButtonClasses()"
      ng-disabled="$ctrl.loading"
      ng-click="$ctrl.handleAppleLogin()"
    >
      <span ng-class="$ctrl.logoClass" ng-bind-html="$ctrl.trustedAppleLogo" aria-hidden="true"></span>
      <span>{{ $ctrl.appleText }}</span>
    </button>

    <button
      ng-if="$ctrl.showGoogle"
      type="button"
      ng-class="$ctrl.getGoogleButtonClasses()"
      ng-disabled="$ctrl.loading"
      ng-click="$ctrl.handleGoogleLogin()"
    >
      <span ng-class="$ctrl.logoClass" ng-bind-html="$ctrl.trustedGoogleLogo" aria-hidden="true"></span>
      <span>{{ $ctrl.googleText }}</span>
    </button>
  </div>

  <!-- ===== DIVISOR "O con tu correo" ===== -->
  <p ng-if="$ctrl.showSocial" class="${BASE_CLASSES.divider}">{{ $ctrl.dividerText }}</p>

  <!-- ===== FORM (email + password + error + submit) ===== -->
  <form ng-submit="$ctrl.handleSubmit()" novalidate class="${BASE_CLASSES.form}">
    <ec-input-text
      ng-model="$ctrl.email"
      placeholder="{{ $ctrl.emailPlaceholder }}"
      icon="person"
      type="email"
      name="email"
      autocomplete="username"
      error="$ctrl.hasError"
      disabled="$ctrl.loading"
    ></ec-input-text>

    <ec-input-password
      class="${BASE_CLASSES.passwordSpacing}"
      ng-model="$ctrl.password"
      placeholder="{{ $ctrl.passwordPlaceholder }}"
      autocomplete="current-password"
      error="$ctrl.hasError"
      disabled="$ctrl.loading"
    ></ec-input-password>

    <p ng-if="$ctrl.errorMessage" role="alert" class="${BASE_CLASSES.errorSpacing} ec-text-caption ec-font-medium ec-text-color-text-danger">{{ $ctrl.errorMessage }}</p>

    <ec-button
      class="${BASE_CLASSES.submitSpacing}"
      intent="primary"
      size="lg"
      block="true"
      type="submit"
      loading="$ctrl.loading"
      label="{{ $ctrl.submitText }}"
    ></ec-button>
  </form>

  <!-- ===== LINK "¿Olvidaste tu contraseña?" ===== -->
  <button
    type="button"
    class="${BASE_CLASSES.forgotLink}"
    ng-click="$ctrl.handleForgotPassword()"
  >{{ $ctrl.forgotText }}</button>

  <!-- ===== DIVISOR + REGISTRO ===== -->
  <div class="${BASE_CLASSES.hr}"></div>
  <p class="${BASE_CLASSES.registerLine}">
    {{ $ctrl.registerQuestion }}
    <button type="button" class="${BASE_CLASSES.registerLink}" ng-click="$ctrl.handleRegister()">{{ $ctrl.registerText }}</button>
  </p>

  <!-- ===== FOOTER TÉRMINOS (opt-in: show-terms + al menos un texto de link) ===== -->
  <p ng-if="$ctrl.showTerms && ($ctrl.termsLinkText || $ctrl.privacyLinkText)" class="${BASE_CLASSES.terms}">
    {{ $ctrl.termsPrefix }}
    <button type="button" class="${BASE_CLASSES.termsLink}" ng-click="$ctrl.handleTerms()">{{ $ctrl.termsLinkText }}</button>
    {{ $ctrl.termsConnector }}
    <button type="button" class="${BASE_CLASSES.termsLink}" ng-click="$ctrl.handlePrivacy()">{{ $ctrl.privacyLinkText }}</button>
  </p>
</div>
`;

export default LOGIN_TEMPLATE;
